import { createAsyncAction } from 'typesafe-actions';
import { Organization, OrganizationDto } from '@rootCommon/types/organization';

export const fetchOrganization = createAsyncAction(
  'FETCH_ORGANIZATION_REQUEST',
  'FETCH_ORGANIZATION_SUCCESS',
  'FETCH_ORGANIZATION_FAILURE',
)<undefined, Organization, Error>();

export const updateOrganization = createAsyncAction(
  'UPDATE_ORGANIZATION_REQUEST',
  'UPDATE_ORGANIZATION_SUCCESS',
  'UPDATE_ORGANIZATION_FAILURE',
)<OrganizationDto, Organization, Error>();

export const fetchOrganizationTitle = createAsyncAction(
  'FETCH_ORGANIZATION_TITLE_REQUEST',
  'FETCH_ORGANIZATION_TITLE_SUCCESS',
  'FETCH_ORGANIZATION_TITLE_FAILURE',
)<undefined, Pick<OrganizationDto, 'title'>, Error>();
